import styled from "styled-components";

const filterProps = (prop: string) => ![""].includes(prop);

export const Container = styled.article.withConfig({
  shouldForwardProp: filterProps,
})`
  width: 120px;
  height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 0 10px;
  box-sizing: border-box;
  position: relative;
  gap: 6px;
  border-radius: 5px;
  &:hover {
    background-color: #eef5fb;
  }
`;

export const ContainerIcon = styled.div.withConfig({
  shouldForwardProp: filterProps,
})`
  width: auto;
  height: auto;
  position: absolute;
  top: 5px;
  right: 0;
`;

export const ContainerImg = styled.div.withConfig({
  shouldForwardProp: filterProps,
})`
  width: 60px;
  height: 76px;
`;

export const Image = styled.img.withConfig({
  shouldForwardProp: filterProps,
})`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const DocumentName = styled.p.withConfig({
  shouldForwardProp: filterProps,
})`
  width: 100%;
  min-height: auto;
  max-height: 24px;
  margin: 0;
  padding: 0;
  font-size: 11px;
  font-weight: normal;
  text-align: center;
  line-height: 1.2;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #0076FF;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Máximo 2 líneas */
  -webkit-box-orient: vertical;
  word-break: break-word;
`;
